import BookShelf from './BookShelf'
import type { BookShelfProps } from './BookShelf.types'

export default BookShelf

export type { BookShelfProps }
